const theme = {
  colors: {
    primary: "#32A6D5",
  },
};

export default theme;
